import { Component, Input, OnInit } from '@angular/core';
import { PopoverController } from '@ionic/angular';
import { filter, first, map } from 'rxjs/operators';
import { AuthService } from 'src/app/services';
import { environment } from 'src/environments/environment';
import { ReferralService } from '../../referral/service/referral.service';
import { HttpClient } from '@angular/common/http';

@Component({
	selector: 'app-share',
	templateUrl: './share.component.html',
	styleUrls: ['./share.component.scss'],
})
export class ShareComponent implements OnInit {
	@Input() sprintData: any;

	refLink = environment.url.rUrl + 'referral/';

	refURL = '';
	currentWeek = '';
	constructor(
		private popoverController: PopoverController,
		private authService: AuthService,
		private referralService: ReferralService,
		private http: HttpClient,
	) {
		this.referralService
			.loadReferralData()
			.pipe(
				map((data: any) => {
					if (data.data && data.data.length > 0) {
						return data.data[0];
					} else {
						return {
							schemeName: 'None',
							schemeId: 1,
							discCode: '',
							balance: 0,
							count: 0,
							signUp: true,
						};
					}
				}),
				map((data: any) => ({
					...data,
					refCode: this.refLink + data.discCode,
					isWallet: data.balance !== 0,
				})),
				filter((data: any) => data && data.refCode),
				first(),
			)
			.subscribe(data => {
				this.refURL = data.refCode;
			});
	}

	ngOnInit() {
		this.http
			.get<any>(
				`https://cohort.terra.do/cohort/list/cohort/${this.sprintData.cohortId}/property`,
			)
			.subscribe((data2: any) => {
				const matchData1 = data2.filter(course => course.name === 'weeks');
				if (matchData1.length === 1) {
					this.currentWeek = matchData1[0].value;
				}
			});
	}

	getCertificateUrl(certUrl: string): string {
		if (!certUrl) {
			console.error('No certificate URL found.');
			return '';
		}

		const uuidMatch = certUrl.match(/([a-f0-9\-]{36})/);

		if (!uuidMatch) {
			console.error('UUID not found in the certificate URL');
			return '';
		}

		const extractedUuid = uuidMatch[0];
		return `https://certificates.terra.do/fellow/${extractedUuid}`;
	}

	postCertificate(course: any = this.sprintData) {
		const newCertUrl = this.getCertificateUrl(course.certificateUrl);
		if (!newCertUrl) {
			return '';
		}

		const params = new URLSearchParams({
			name: course.courseName || '',
			organizationId: '43175859',
			issueMonth: (new Date(course.issuedOn).getMonth() + 1).toString(),
			issueYear: new Date(course.issuedOn).getFullYear().toString(),
			certUrl: newCertUrl,
			isFromA2p: 'true',
		});

		const baseUrl =
			'https://www.linkedin.com/profile/add?startTask=CERTIFICATION_NAME';
		window.open(`${baseUrl}&${params.toString()}`, '_blank');

		this.popoverController.dismiss();
	}

	public copyToClipboardShare(s) {
		this.copyText(s);

		this.authService.addToastMsg('Share text copied to clipboard as well.');
	}

	textArea: any;
	copy;

	isOS() {
		return navigator.userAgent.match(/ipad|iphone/i);
	}

	createTextArea(text) {
		this.textArea = document.createElement('textArea');
		this.textArea.value = text;
		document.body.appendChild(this.textArea);
	}

	selectText() {
		var range, selection;

		if (this.isOS()) {
			range = document.createRange();
			range.selectNodeContents(this.textArea);
			selection = window.getSelection();
			selection.removeAllRanges();
			selection.addRange(range);
			this.textArea.setSelectionRange(0, 999999);
		} else {
			this.textArea.select();
		}
	}

	copyToClipboard() {
		document.execCommand('copy');
		document.body.removeChild(this.textArea);
	}

	copyText(text) {
		this.createTextArea(text);
		this.selectText();
		this.copyToClipboard();
	}

	postLinkedIn(course: any = this.sprintData) {
		const newCertUrl = this.getCertificateUrl(course.certificateUrl);
		if (!newCertUrl) {
			return '';
		}

		const text_linked_facebook =
			'🌍 Exciting news to share! 🌍' +
			'\n\n' +
			'I’ve recently completed the ' +
			course.courseName +
			` with Terra.do. It is a ${this.currentWeek}-week climate program covering the climate science, impacts, and solutions, to get you working on climate.` +
			'\n\n' +
			'For me, this experience has been transformative—it’s given me the knowledge, tools, and community to take meaningful steps in my climate journey. If you’ve been wanting to move from awareness to action, this is an incredible way to start! 🌱' +
			'\n\n' +
			`If you're curious about the fellowship or want to hear more about my experience, drop your questions in the comments—I’d be happy to help! You can also get 20% off the program price by using my referral.` +
			'\n\n' +
			`Use this link to apply: ` +
			this.refURL +
			'\n\n' +
			'#ClimateAction #ClimateCareers #ClimateUpskilling' +
			'\n\n' +
			`🎓 Here's my certificate! ` +
			newCertUrl;

		this.copyToClipboardShare(text_linked_facebook);

		window.open(
			`https://www.linkedin.com/feed/?shareActive=true&text=${encodeURIComponent(
				text_linked_facebook,
			)}`,
			'_blank',
		);

		// window.open(
		// 	`https://www.linkedin.com/shareArticle?mini=true&url=${encodeURIComponent(
		// 		newCertUrl,
		// 	)}&title=${encodeURIComponent(
		// 		course.courseName || '',
		// 	)}&summary=${encodeURIComponent(text_linked_facebook)}&source=terra.do`,
		// 	'_blank',
		// );
		//www.linkedin.com/shareArticle?mini=true&url={URL}&title={TITLE}&summary={SUMMARY}&source={SOURCE}

		this.popoverController.dismiss();
	}
}
